import React, { useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import useRemoteDomain from "../../../../hooks/queryResults/remote/useRemoteDomain";
import useRemoteTemplates from "../../../../hooks/queryResults/remote/useRemoteTemplates";
import Util from "../../../../util/util";
import Table from "../../../layout/Table";
import Loading from "../../../ui/Loading";

export default function AdminRemoteDomain() {
  const history = useHistory();
  const domain = useRemoteDomain();
  const { templates, remoteTemplatesQuery } = useRemoteTemplates();

  const infoColumns = useMemo(
    () => Util.makeTableColumns(["key", "value"]),
    []
  );

  const infoData = useMemo(
    () => [
      { key: "Progress", value: Util.getProgressIcon(domain?.progress) },
      { key: "Status", value: domain?.status },
      { key: "Templates", value: domain?.numTemplates },
    ],
    [domain]
  );

  const templateColumns = useMemo(
    () =>
      Util.makeTableColumns([
        { value: "name", className: "left" },
        { value: "url", className: "left" },
        "sources",
        "priority",
        "status",
        "progress",
      ]),
    []
  );

  const templateData = useMemo(() => {
    const makeData = (templates) => {
      const data = [];

      if (templates) {
        const templatesArray = Object.keys(templates)
          .map((id) => templates[id])
          .sort((a, b) => {
            if (a.name === b.name) return 0;
            return a.name < b.name ? -1 : 1;
          });

        templatesArray.forEach((template) => {
          data.push({
            name: (
              <Link to={`/admin/remote/${domain?.slug}/${template?.slug}`}>
                {template.name}
              </Link>
            ),
            url: <a href={template.url}>{template.url}</a>,
            sources: template.numSources,
            priority: template.priority,
            status: template.status,
            progress: (
              <Link
                style={{ textDecoration: "none" }}
                to={`/admin/remote/${domain?.slug}/${template?.slug}`}
              >
                {Util.getProgressIcon(template.progress)}
              </Link>
            ),
          });
        });
      }

      return data;
    };

    return makeData(templates);
  }, [domain, templates]);

  if (remoteTemplatesQuery.isLoading) return <Loading />;

  if (templates && domain) {
    return (
      <>
        <h1>
          <Link to={"/admin"}>Admin</Link> -{" "}
          <Link to={"/admin/remote"}>Remote Data</Link> - {domain.name}
        </h1>
        <button
          className={"btn"}
          onClick={(e) => {
            e.preventDefault();
            history.push("/admin/remote/config/add");
          }}
        >
          Add Config
        </button>
        <h2>Info</h2>
        <Table columns={infoColumns} data={infoData} />
        <h2>Templates</h2>
        <Table columns={templateColumns} data={templateData} />
      </>
    );
  }

  return null;
}
